import { commonComponents as cc } from "@/components/common";
import GoToPatientsCard from "@/features/patients/components/GoToPatientsCard";
import JourneyProgress from "@/features/onboarding/components/JourneyProgress";
import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import MissingProfileItemsCallouts from "@/features/profile/components/MissingProfileItemsCallouts";
import MissingOrganisationAlert from "@/features/profile/components/MissingOrganisationAlert";
import Profile from "@/features/profile/components/Profile";
import { useAuth } from "@/utils/auth";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { useProfileCopy } from "@/features/i18n/profileCopy";
import { NotificationsDisabledCallout } from "@/features/knock/components/NotificationsDisabledCallout";
import MissingBillingAlert from "../../../features/billing/components/MissingBillingAlert";

const ProfilePage = () => {
    const auth = useAuth();
    const copy = useProfileCopy();

    const { data: profile } = useSuspenseQuery(selectProfileByIdQueryOptions(auth.id));

    return (
        <Suspense>
            <cc.Title words={copy.title} description={copy.description} />
            <NotificationsDisabledCallout />
            <MissingBillingAlert />
            <MissingProfileItemsCallouts />
            {auth.roles?.isPatient ? <JourneyProgress className="mb-4" /> : null}
            <MissingOrganisationAlert />
            {(auth.roles?.isClinician || auth.roles?.isSecretary || auth.roles.isAdmin) && <GoToPatientsCard />}
            <Profile profile={profile} />
        </Suspense>
    );
};
export const Route = createFileRoute("/_app/profile/")({
    component: ProfilePage,
});

export default Profile;
